import CashTamerHttpClient from './CashTamerHttpClient';
import CashTamerApiBase from './CashTamerApiBase';
import SignInRequestModel from '@/models/security/SignInRequestModel';
import SignInResponseModel from '@/models/security/SignInResponseModel';
import InitiatePrimaryPasswordResetRequestModel from '@/models/security/InitiatePrimaryPasswordResetRequestModel';
import ResetPrimaryPasswordRequestModel from '@/models/security/ResetPrimaryPasswordRequestModel';

export default class SecurityApi extends CashTamerApiBase {
    public async signInAsync(request: SignInRequestModel): Promise<SignInResponseModel> {

        try {
            const httpClient = new CashTamerHttpClient();

            const httpResponse = await httpClient.postAsync('security/signin', request);

            const response = new SignInResponseModel();
            response.givenName = httpResponse.data.givenName;
            response.surname = httpResponse.data.surname;
            response.jwt = httpResponse.data.jwt;
            response.jwtExpirationMs = httpResponse.data.jwtExpirationMs;
            response.firstTimeSigningIn = httpResponse.data.firstTimeSigningIn;

            return response;
        }
        catch ( err ) {
            return this.handleApiError(err);
        }
    }

    public async initiatePrimaryPasswordResetAsync(request: InitiatePrimaryPasswordResetRequestModel): Promise<void> {

        try {
            const httpClient = new CashTamerHttpClient();

            await httpClient.postAsync('security/primarypassword/initiatereset', request);
        }
        catch ( err ) {
            return this.handleApiError(err);
        }
    }

    public async resetPrimaryPasswordAsync(request: ResetPrimaryPasswordRequestModel): Promise<void> {

        try {
            const httpClient = new CashTamerHttpClient();

            await httpClient.postAsync('security/primarypassword/reset', request);
        }
        catch ( err ) {
            return this.handleApiError(err);
        }
    }
}
